import Swiper from 'swiper/bundle';

window.Swiper = Swiper;


$(document).ready(function() {

    if ($('[data-logo_slider]').length) {

        var $pagination = $('[data-logo_slider]').parents('.content-wrap').find('.swiper-pagination')
        

        var mySwiper = new Swiper('[data-logo_slider]', {
            speed: 300,
            grabCursor: true,
            spaceBetween: 32,

            slidesPerView: 4,
            slidesPerColumn: 2,
            slidesPerGroup: 4,
            grabCursor: true,
            pagination: {
                el: $pagination.get(0),
                clickable: true,
            },


            breakpoints: {

                0: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                },
                575: {
                    slidesPerView: 3,
                    slidesPerColumn: 2,
                    slidesPerGroup: 3,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 4,
                    slidesPerColumn: 2,
                    slidesPerGroup: 4,
                },
            }
        });
    }

});